import React from 'react'
import { PropTypes } from 'prop-types'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

const Button = props => (
  <button
    id={props.id}
    value={props.value}
    onClick={e => props.action(e.target.value)}
    disabled={!!props.disabled}
    {...css(
      props.styles.button,
      props.styles[`button--${props.type}`],
      props.styles[`button--pull-${props.pullTo}`],
      props.styles[`button--display-${props.display}`],      
      (props.id === 'DIFARMA_0-FIRMA' ||  props.id === 'DIFARMA_1-FIRMA' || props.id === 'DIFARMA_2-FIRMA' ||
      props.id === 'DIFARMA_3-FIRMA' || props.id === 'DIFARMA_4-FIRMA' || props.id === 'DIFARMA_5-FIRMA') 
      ? props.styles[`button--firma`] : ''  
    )}
  >
    {(props.value === 'Firmato' || props.value === 'Attivata') ? (<b>&#10004; Firmato</b>) : props.text}
  </button>
)

Button.propTypes = {
  id: PropTypes.string,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'primary',
    'inverse',
    'primary-inverse',
    'sella',
    'active',
    'secondry',
    'delete'
  ]),
  disabled: PropTypes.bool,
  pullTo: PropTypes.oneOf(['left', 'right']),
  action: PropTypes.func.isRequired,
  styles: PropTypes.object.isRequired
}

export default withStyles(Styles)(Button)



// WEBPACK FOOTER //
// ./components/button/index.js